/** Public page shown when a QCS handoff sign-in is rejected (400). */
export const QCS_HANDOFF_ERROR_PATH = '/qcs-login-error'

/** Backend Auth0 callback failures land here with `?reason=<snake_case>`. */
export const QCS_ACCESS_DENIED_PATH = '/access-denied'

export const HANDOFF_ERROR = {
  NO_ACCESS: 'no-access',
  ACCOUNT_DEACTIVATED: 'account-deactivated',
  TRY_AGAIN: 'try-again',
}

export const HANDOFF_ERROR_MESSAGE = {
  [HANDOFF_ERROR.NO_ACCESS]: "You don't have access to this feature",
  [HANDOFF_ERROR.ACCOUNT_DEACTIVATED]: 'Account has been deactivated',
  [HANDOFF_ERROR.TRY_AGAIN]: 'Something went wrong, please try again later',
}

// Only the backend Auth0 callback reports a deactivated account.
const DEACTIVATED_REASONS = ['account_inactive']

// Auth0 callback failures that are not a permissions or deactivation result.
const TRY_AGAIN_REASONS = ['unexpected_error', 'authentication_error']

/** Every handoff 400 shows the "no access" page. */
export const handoffErrorReasonFromBody = () => HANDOFF_ERROR.NO_ACCESS

/** Deactivated and try-again reasons get their own message; everything else is "no access". */
export const getHandoffErrorMessage = search => {
  const reason = new URLSearchParams(search || '').get('reason')
  if (DEACTIVATED_REASONS.includes(reason)) return HANDOFF_ERROR_MESSAGE[HANDOFF_ERROR.ACCOUNT_DEACTIVATED]
  if (TRY_AGAIN_REASONS.includes(reason)) return HANDOFF_ERROR_MESSAGE[HANDOFF_ERROR.TRY_AGAIN]
  return HANDOFF_ERROR_MESSAGE[HANDOFF_ERROR.NO_ACCESS]
}
